<template>
  <div class="container-fluid im-fluid" @click="$root.hideMenu">
    <div class="row justify-content-center">
      <div class="col-4 col-sm-12 col-md-4 text-center">
        <h5 class="mb-3">Грешка 404</h5>

        <p>Страницата която търсите не съществува!</p>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "Error404",
  };
</script>
